var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-preset-dashboard',[_c('div',[_c('h1',{staticClass:"h5 mb-16"},[_vm._v(_vm._s(_vm.$t((_vm.i18n + ".title"))))])]),_c('table-base',{attrs:{"data":_vm.roles,"table-layout":_vm.tableLayout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }